import { useState } from 'react';

const faqs = [
  {
    question: '医療用ホワイトニングシートと市販品の違いは何ですか？',
    answer: '市販品には法律上、過酸化水素などの医療用成分を配合することができません。当サービスでは歯科医師による診療を経て、医療機関のみが取り扱える高濃度の有効成分を配合したシートをご提供しています。そのため、市販品では実現できない本格的な白さを自宅で体験いただけます。',
  },
  {
    question: '電話診療はどのように行われますか？',
    answer: 'LINEでご予約後、担当の歯科医師より指定のお時間にお電話いたします。診療時間は約10〜15分程度で、現在の歯の状態や過去の治療歴、アレルギーの有無などを確認します。診療後、問題がなければ処方・発送手続きに進みます。',
  },
  {
    question: '効果が出るまでどのくらいかかりますか？',
    answer: '個人差はありますが、多くの方が1〜2週間の使用で効果を実感されています。',
  },
  {
    question: '妊娠中・授乳中でも使用できますか？',
    answer: '妊娠中・授乳中の方への使用は推奨しておりません。安全性が確認されていないため、ご出産・授乳期間終了後にご利用ください。',
  },
  {
    question: '差し歯・被せ物・ホワイトニング済みの歯にも効果がありますか？',
    answer: '天然歯（自分の歯）にのみ効果があります。差し歯・被せ物・詰め物・インプラントなどの人工物には効果がありません。また、すでにホワイトニング済みの歯に対しては、現状維持・再着色防止の効果が期待できます。',
  },
  {
    question: '定期購入の縛りはありますか？',
    answer: '定期購入の縛りは一切ございません。',
  },
  {
    question: '支払い方法は何が使えますか？',
    answer: 'クレジットカードのみご利用いただけます。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-[#F8FBFF]">
      <div className="max-w-3xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-[#E3F2FD] text-[#2C5AA0] text-sm font-semibold rounded-full mb-4">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            よくあるご質問
          </h2>
          <p className="text-gray-500 text-sm">
            ご不明な点はLINEでもお気軽にご相談ください。
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl border transition-all duration-300 overflow-hidden ${
                openIndex === index ? 'border-[#4A90E2] shadow-md' : 'border-gray-200 shadow-sm'
              }`}
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center bg-[#E3F2FD] text-[#2C5AA0] text-sm font-bold rounded-full mt-0.5">
                    Q
                  </span>
                  <span className="text-sm font-semibold text-gray-800 leading-relaxed">
                    {faq.question}
                  </span>
                </div>
                <span className={`flex-shrink-0 w-7 h-7 flex items-center justify-center ml-4 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xl text-[#4A90E2]"></i>
                </span>
              </button>

              <div
                className={`transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                } overflow-hidden`}
              >
                <div className="px-6 pb-5 flex items-start gap-4">
                  <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center bg-[#E8F5E9] text-[#2E7D32] text-sm font-bold rounded-full mt-0.5">
                    A
                  </span>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center bg-white rounded-2xl border border-[#E3F2FD] p-8 shadow-sm">
          <p className="text-gray-700 font-semibold mb-2">他にご不明な点はございますか？</p>
          <p className="text-sm text-gray-500 mb-6">LINEにてお気軽にご相談ください。歯科医師が丁寧にお答えします。</p>
          <a
            href="https://lin.ee/voFYYoK"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 bg-[#00C853] text-white font-bold rounded-full hover:bg-[#00B248] transition-colors shadow-md whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-lg"></i>
            LINEで質問する
          </a>
        </div>
      </div>
    </section>
  );
}
